//
//
//
//
import echarts from "echarts";
import { debounce } from '@/utils';
export default {
  props: ["chartData", "lendName", "total"],
  data: function data() {
    return {
      chart: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.initChart();
    this.__resizeHanlder = debounce(function () {
      if (_this.chart) {
        _this.chart.resize();
      }
    }, 100);
    window.addEventListener("resize", this.__resizeHanlder);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.dispose();
    this.chart = null;
    window.removeEventListener('resize', this.__resizeHanlder);
  },
  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.setOptions(val);
      }
    }
  },
  methods: {
    setOptions: function setOptions() {
      var data = []; // 颜色系列

      var colorList = [{
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0,
          color: 'rgba(0, 178, 255, 1)' // 0% 处的颜色

        }, {
          offset: 1,
          color: 'rgba(0, 114, 255, 1)' // 100% 处的颜色

        }]
      }, {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0,
          color: 'rgba(0, 180, 255, 1)' // 0% 处的颜色

        }, {
          offset: 1,
          color: 'rgba(112, 238, 254, 1)' // 100% 处的颜色

        }]
      }, {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0,
          color: 'rgba(167, 125, 255, 1)' // 0% 处的颜色

        }, {
          offset: 1,
          color: 'rgba(243, 209, 255, 1)' // 100% 处的颜色

        }]
      }]; // 循环添加数据

      for (var i = 0; i < this.lendName.length; i++) {
        data.push({
          name: this.lendName[i],
          value: this.chartData[i],
          itemStyle: {
            color: colorList[i]
          }
        });
      }

      var option = {
        //color: ["#145ff0", "#1dead5",],
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c}元"
        },
        title: {
          itemGap: 0,
          text: "总计应收",
          subtext: this.total + "元",
          x: "center",
          top: "42%",
          textAlign: "center",
          left: "48%",
          textStyle: {
            fontSize: "10",
            fontWeight: "bolder",
            color: "#fff"
          },
          subtextStyle: {
            lineHeight: 26,
            rich: {
              a: {}
            },
            color: "#fff",
            fontSize: "12"
          }
        },
        series: [{
          type: "pie",
          radius: ["35%", "65%"],
          center: ["50%", "50%"],
          label: {
            normal: {
              formatter: "{per|{b}:\n{c}元}",
              rich: {
                per: {
                  color: '#fff',
                  align: 'center'
                }
              }
            }
          },
          labelLine: {
            normal: {
              length: 1
            }
          },
          data: data
        }]
      };
      this.chart.setOption(option);
    },
    initChart: function initChart() {
      this.chart = echarts.init(this.$refs.statusEchart, 'macarons');
      this.setOptions();
    }
  }
};